import { SlugBlacklistRepository } from '@lib/api/repository/slug-blacklist';
import {
  SlugPatternInput,
  UpdateSlugPatternInput,
} from '@lib/types/slug-blacklist';

import { Requester } from '../clients';

interface EntryDTO {
  id: string;
  pattern: string;
}

const PATH = '/marketplace/admin/slug-blacklist';
const toEntry = ({ id, pattern }: EntryDTO) => ({ id, pattern });

export default class SlugBlacklistAPI implements SlugBlacklistRepository {
  async list(signal?: AbortSignal) {
    const { data } = await Requester.get<EntryDTO[]>(PATH, { signal });
    return data.map(toEntry);
  }

  async create(input: SlugPatternInput) {
    const { data } = await Requester.post<EntryDTO>(PATH, {
      body: { pattern: input.pattern },
    });

    return toEntry(data);
  }

  async update(input: UpdateSlugPatternInput) {
    const { data } = await Requester.patch<EntryDTO>(`${PATH}/${input.id}`, {
      body: { pattern: input.pattern },
    });

    return toEntry(data);
  }

  async delete(id: string) {
    await Requester.delete(`${PATH}/${id}`);
  }
}
